module.exports = __webpack_public_path__ + "img/remove_tray_and_box2.7643fefc.png";